import { View } from "@react-pdf/renderer";
import { useMemo } from "react";

const PdfSection = ({ children, gap = 1, style }) => {
  const styles = useMemo(() => {
    return {
      marginBottom: 15,
      paddingTop: 14,
      paddingBottom: 14,
      ...style,
    };
  }, [style]);

  return <View style={styles}>{children}</View>;
};

export default PdfSection;
